import { render, staticRenderFns } from "./SummaryNextSteps.vue?vue&type=template&id=67cd20c4&"
import script from "./SummaryNextSteps.vue?vue&type=script&lang=js&"
export * from "./SummaryNextSteps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports